/**
 * Native iOS/Android root-tab navigation helper.
 *
 * Tab switches (Home / Categories / Messages / Account / Header home logo)
 * must reset the logical back stack — otherwise swipe-back after a tab
 * switch lands on screens from the previous tab's deep navigation.
 *
 * The function:
 *   1. Resets the logical app-history stack to a single root entry at
 *      `href` (see `appHistory.ts` for why the logical stack is the source
 *      of truth on native, not WKWebView's back-forward list).
 *   2. Calls `replaceState` to update the browser URL to the new tab,
 *      which wouter's monkey-patched `replaceState` re-dispatches as a
 *      synthetic `replaceState` event so subscribers re-render.
 *   3. Manually fires a `popstate` so legacy listeners that only listen
 *      to popstate are also notified.
 *
 * This is only invoked from the bottom-tab buttons and the Header home
 * logo when running inside a Capacitor native shell. Web builds use
 * standard wouter `<Link>` components — completely unaffected.
 */

import { appHistoryReset } from "./appHistory";

export function nativeTabNavigate(href: string): void {
  if (typeof window === "undefined") return;
  appHistoryReset(href);
  window.history.replaceState(null, "", href);
  window.dispatchEvent(new PopStateEvent("popstate", { state: null }));
}
